/**
 * Shared formatting constants.
 *
 * NOT MONEY. This folder deliberately contains no currency, price or amount
 * formatting of any kind. DQ-01 (money representation) is unapproved, and
 * writing a formatter would silently adopt a representation nobody has signed
 * off. See design spec §4.3.
 */

/**
 * Rendered wherever a value cannot be formatted. A visible em dash says "there
 * is nothing here" without claiming the value was zero, empty or successful —
 * three very different stories that a blank string would collapse into one.
 */
export const EMPTY_PLACEHOLDER = '—';

/**
 * The admin renders numbers and dates in one locale regardless of the browser's
 * setting. An operations tool whose columns reflow between `1,234` and
 * `1.234` depending on the operator's machine is an operations tool nobody
 * trusts with a screenshot.
 */
export const ADMIN_LOCALE = 'en-US';
